(() => {
  const rootSelector = '[data-nord-product-compatibility]';
  const roots = Array.from(document.querySelectorAll(rootSelector));
  if (!roots.length) return;

  const url = roots.find((r) => r.dataset.compatibilityUrl)?.dataset.compatibilityUrl;
  if (!url) return;

  const esc = (value) => String(value ?? '').replace(/[&<>'"]/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[c]));

  const normalizeSku = (value) => String(value || '')
    .replace(/\u00a0/g, ' ')
    .replace(/[–—−]/g, '-')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();

  const renderFallback = (root) => {
    root.innerHTML = `
      <details class="nord-compatibility-card">
        <summary>
          <span>Fits these vehicles</span>
          <small>VIN/OEM verification required</small>
        </summary>
        <div class="nord-compatibility-card__body">
          <p>A confirmed vehicle list is not available for this product in the current NORD fitment catalogue.</p>
          <p class="nord-compatibility-card__note">For accurate fitment information, email <a href="mailto:sales@nordautoparts.ca">sales@nordautoparts.ca</a> before ordering.</p>
        </div>
      </details>`;
  };

  fetch(url, { credentials: 'same-origin', cache: 'force-cache' })
    .then((response) => {
      if (!response.ok) throw new Error(`Compatibility data HTTP ${response.status}`);
      return response.json();
    })
    .then((data) => {
      const normalized = new Map();
      Object.entries(data || {}).forEach(([sku, matches]) => {
        normalized.set(normalizeSku(sku), Array.isArray(matches) ? matches : []);
      });

      roots.forEach((root) => {
        const rawSku = root.dataset.sku || '';
        const matches = normalized.get(normalizeSku(rawSku)) || [];
        if (!matches.length) {
          renderFallback(root);
          return;
        }

        const rows = matches.map(([make, model, years]) =>
          `<li><strong>${esc(make)}</strong> ${esc(model)} <span>${esc(years)}</span></li>`
        ).join('');

        const countLabel = `${matches.length} matching vehicle model${matches.length === 1 ? '' : 's'}`;
        root.innerHTML = `
          <details class="nord-compatibility-card">
            <summary>
              <span>Fits these vehicles</span>
              <small>${esc(countLabel)}</small>
            </summary>
            <div class="nord-compatibility-card__body">
              <p>This part is listed in the current NORD supplier fitment catalogue for the following vehicles:</p>
              <ul>${rows}</ul>
              <p class="nord-compatibility-card__note">Fitment can vary by engine, transmission, chassis, production date and factory options. For accurate fitment information, email <a href="mailto:sales@nordautoparts.ca">sales@nordautoparts.ca</a>.</p>
            </div>
          </details>`;
      });
    })
    .catch(() => {
      roots.forEach(renderFallback);
    });
})();
